import Splide from '@splidejs/splide';

export const ProductImageCarousel = () => {
    document.addEventListener('DOMContentLoaded', function () {
        if (document.getElementById('product-thumbnail-carousel') !== null && document.getElementById('product-main-carousel') !== null) {


            const main = new Splide('#product-main-carousel', {
                type: 'slide',
                rewind: true,
                pagination: false,
                arrows: false,
            });

            const thumbnails = new Splide('#product-thumbnail-carousel', {
                fixedWidth: 100,
                fixedHeight: 100,
                gap: 10,
                rewind: true,
                pagination: false,
                isNavigation: true,
                cover: true,
                mediaQuery: 'min',
                breakpoints: {
                    800: {
                        fixedWidth: 150,
                        fixedHeight: 150,
                    },
                }
            });

            main.sync(thumbnails);
            main.mount();
            thumbnails.mount();

            let sliderAppendedWithVariation = false;

            $('form.variations_form').on('show_variation', function (event, data) {
                if (!sliderAppendedWithVariation) {
                    main.add(`<li class="splide__slide"><img src="${data.image.url}" alt=""></li>`, 0);
                    thumbnails.add(`<li class="splide__slide"><img src="${data.image.url}" alt=""></li>`, 0);
                    main.go(0);
                    thumbnails.go(0);
                    sliderAppendedWithVariation = true;
                } else {
                    main.remove(0);
                    thumbnails.remove(0);
                    main.add(`<li class="splide__slide"><img src="${data.image.url}" alt=""></li>`, 0);
                    thumbnails.add(`<li class="splide__slide"><img src="${data.image.url}" alt=""></li>`, 0);
                    main.go(0);
                    thumbnails.go(0);
                }

            });

        }
    });
};